// extracted by mini-css-extract-plugin
export var actionText = "_oa-4";
export var container = "_oa-0";
export var leftSection = "_oa-1";
export var rightSection = "_oa-2";
export var settingsButton = "_oa-6";
export var settingsIcon = "_oa-7";
export var shortcut = "_oa-5";
export var shortcutGroup = "_oa-3";